<template>
  <section class="ceo-section">
    <div class="container">
      <div class="row align-items-center">
        <!-- FOTO -->
        <div class="col-lg-4 col-md-5 col-12 text-center">
          <div class="ceo-photo-wrapper">
            <img class="ceo-photo" :src="ceoImage" alt="CEO Plotix" />
          </div>
        </div>

        <!-- TEXTO PRINCIPAL + DESPLEGABLE -->
        <div class="col-lg-8 col-md-7 col-12">
          <div class="ceo-content">
            <span class="ceo-badge">Dirección técnica - CEO</span>
            <h2 class="ceo-name">{{ ceoName }}</h2>

            <p class="ceo-summary">
              {{ ceoSummary }}
            </p>

            <!-- Botón / toggle -->
            <button class="ceo-toggle-btn" @click="isOpen = !isOpen">
              <span>{{ isOpen ? 'Ocultar trayectoria' : 'Ver trayectoria completa' }}</span>
              <i class="bx" :class="isOpen ? 'bx-chevron-up' : 'bx-chevron-down'"></i>
            </button>

            <!-- Contenido desplegable -->
            <transition name="fade-slide">
              <div v-if="isOpen" class="ceo-details">
                <div v-for="(job, idx) in ceoExperience" :key="idx" class="ceo-exp-card">
                  <div class="ceo-exp-header">
                    <div class="ceo-exp-role">{{ job.puesto }}</div>
                    <div class="ceo-exp-company">{{ job.empresa }}</div>
                  </div>

                  <div class="ceo-exp-meta">
                    <span class="ceo-exp-dates">{{ job.fecha }}</span>
                    <span class="ceo-exp-sep">•</span>
                    <span class="ceo-exp-loc">{{ job.ubicacion }}</span>
                  </div>

                  <div class="ceo-exp-desc">
                    <p v-for="(line, i) in job.descripcion" :key="i">
                      {{ line }}
                    </p>
                  </div>
                </div>
              </div>
            </transition>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CeoSection',
  data() {
    return {
      ceoImage: require('@/assets/img/resources/lover2.png'),

      ceoName: 'Michel Conesa',

      ceoSummary:
        'Fundador y Director Técnico de Plotix, con más de dos décadas de experiencia en impresión digital profesional. Ha liderado instalaciones críticas, mantenimientos complejos y producción de campañas para marcas nacionales e internacionales. Su enfoque combina precisión técnica, respuesta rápida y un compromiso absoluto con la continuidad operativa del cliente.',

      // Ahora cada experiencia es un objeto con más estructura
      ceoExperience: [
        {
          puesto: 'Project Manager & Print Manager',
          empresa: 'Grafic Planet',
          fecha: 'ene. 2011 – feb. 2013 · 2 años 2 meses',
          ubicacion: 'Madrid',
          descripcion: [
            'Gestión integral de producción y supervisión técnica de maquinaria industrial de impresión digital.',
            'Coordinación de equipos de trabajo, planificación de tareas y control de calidad de impresión.',
            'Responsable de la ejecución de campañas publicitarias nacionales e internacionales para Movistar, Repsol, Nautalia, Vodafone y El Corte Inglés.',
            'Supervisión del mantenimiento preventivo y correctivo de impresoras de gran formato HP y Vutek.',
            'Implantación de mejoras operativas para optimizar los tiempos de producción.'
          ]
        },
        {
          puesto: 'Field Service Engineer',
          empresa: 'Kodak Solution IPS',
          fecha: 'feb. 2007 – feb. 2009 · 2 años 1 mes',
          ubicacion: 'Valencia',
          descripcion: [
            'Instalación, calibración y mantenimiento de impresoras de alta producción VX5000 para Key S.A.',
            'Participación en el proyecto Versamark, con despliegue técnico de impresoras en entorno de gran volumen (más de 8M€ en equipos).',
            'Soporte técnico en sistemas de impresión continua responsables de la facturación nacional de Movistar.',
            'Colaboración con equipos internacionales de Kodak IPS (Suiza) en pruebas de desarrollo y actualizaciones técnicas.',
            'Formación avanzada recibida en cabezales 1 y 2 inch y sistemas IPS Versamark VX5000.'
          ]
        },
        {
          puesto: 'Field Service Engineer (Gran Formato)',
          empresa: 'Sumo Center Gráfico · Distribuidor oficial HP Large Format',
          fecha: 'nov. 2004 – ene. 2007 · 2 años 3 meses',
          ubicacion: 'Las Rozas de Madrid (Comunidad de Madrid)',
          descripcion: [
            'Instalación, soporte y reparación de impresoras HP de gran formato (series Scitex, TurboJet, DesignJet).',
            'Diagnóstico de averías críticas en hardware, firmware y sistemas de impresión.',
            'Responsable de mantenimiento técnico y asistencia postventa a clientes corporativos.',
            'Formación técnica en HP (Madrid, La Rozas) sobre modelos HP 9000, servidores ProLine y calibración de sistemas RIP.'
          ]
        },
        {
          puesto: 'Print Manager',
          empresa: 'Codice Transfer Factory',
          fecha: 'oct. 2000 – nov. 2004 · 4 años 2 meses',
          ubicacion: 'Málaga',
          descripcion: [
            'Gestión completa de la producción y supervisión del parque de maquinaria de impresión digital.',
            'Formación y liderazgo de técnicos de impresión, tintas y mantenimiento mecánico.',
            'Responsable de testeo de hardware y software EFI Vutek Press Vu 200/600 y 320/400 para sistemas DSCV dinámicos.',
            'Diseño y producción de transferencias textiles y materiales promocionales para clientes como Telefónica Cabitel y Adidas.'
          ]
        },
        {
          puesto: 'Print Manager & Project Manager / I+D',
          empresa: 'Codice',
          fecha: '2004 – (continuidad interna posterior)',
          ubicacion: 'Málaga',
          descripcion: [
            'Liderazgo de proyectos de innovación en impresión digital y materiales.',
            'Participación directa con EFI y Vutek en validaciones de hardware de gran formato y desarrollo de perfiles ICC.',
            'Gestión técnica de mantenimiento y producción de gran formato a nivel nacional.',
            'Colaboración en la integración de sistemas RIP, software EFI y calibraciones avanzadas.'
          ]
        },
        {
          puesto: 'Graphic Designer',
          empresa: 'Codice',
          fecha: 'sept. 1999 – oct. 2000 · 1 año 2 meses',
          ubicacion: 'Málaga',
          descripcion: [
            'Diseño gráfico especializado en transferencias y separaciones de color.',
            'Desarrollo visual para campañas promocionales y soportes publicitarios.',
            'Apoyo técnico en la preparación de archivos para impresión textil y gran formato.'
          ]
        },
        {
          puesto: 'Project Manager',
          empresa: 'Codice',
          fecha: 'sept. 1999 – nov. 2000 · 1 año 3 meses',
          ubicacion: 'Málaga, España',
          descripcion: [
            'Dirección y seguimiento del proyecto nacional Amplia’s (Grupo Wide Boyacá).',
            'Supervisión de implantación técnica y control de calidad en nuevos centros de impresión.',
            'Gestión de cronogramas de entrega, coordinación de proveedores y validación de resultados finales.'
          ]
        },
        {
          puesto: 'Rotating Machinery Operator',
          empresa: 'Avery Dennison',
          fecha: 'oct. 1996 – nov. 1997 · 1 año 2 meses',
          ubicacion: 'Maidenhead, Reino Unido',
          descripcion: [
            'Operador de maquinaria rotativa industrial para producción de etiquetas.',
            'Mantenimiento preventivo y limpieza técnica de sistemas mecánicos de alta velocidad.',
            'Apoyo al ingeniero de máquina en ajustes y calibraciones de línea.'
          ]
        },
        // 🔹 NUEVO BLOQUE – Formación técnica destacada
        {
          puesto: 'Certificaciones y formación técnica destacada',
          empresa: 'Internacional (HP, Vutek, Kodak, Academia 3D Radical)',
          fecha: '1999 – 2007',
          ubicacion: 'España, Bélgica, Suiza e Israel',
          descripcion: [
            'Máster en XSI Softimage (Modelado 3D, Render, Animación y Combustión) – Academia 3D Radical, Málaga.',
            'Máster en Robótica Industrial y PLC – Universidad de Zaragoza.',
            'Curso HP 9000 y servidores ProLine en HP La Rozas (Madrid).',
            'Formación internacional en EFI Vutek Bruselas: tintas UV, cabezales, calibraciones y mantenimiento de sistemas PressVu.',
            'Curso Kodak Versamark VX 5000 IPS y Cabezales 1/2 inch – Centro Kodak Suiza.',
            'Curso HP Scitex en Netanya (Israel) de 3 semanas en desarrollo de impresión gran formato.',
            'FP en Electromecánica – FP Fuengirola (3 años).'
          ]
        }
      ],
      isOpen: false
    };
  }
};
</script>

<style scoped>
/* ====== Layout general ====== */
.ceo-section {
  background: #ffffff;
  padding: 60px 0;
  color: #1a1a1d;
  font-family: inherit;
}

.ceo-photo-wrapper {
  display: inline-block;
  background: #f5f5f5;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.07);
  max-width: 260px;
  width: 100%;
}

.ceo-photo {
  width: 100%;
  height: auto;
  border-radius: 12px;
  object-fit: cover;
  display: block;
}

/* ====== Contenido textual ====== */
.ceo-content {
  margin-top: 20px;
}

.ceo-badge {
  display: inline-block;
  font-size: 12px;
  font-weight: 500;
  background: #1a1a1d;
  color: #fff;
  padding: 4px 10px;
  border-radius: 999px;
  line-height: 1.3;
  margin-bottom: 12px;
}

.ceo-name {
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1d;
  margin: 0 0 12px;
}

.ceo-summary {
  font-size: 15px;
  line-height: 1.6;
  color: #444;
  margin-bottom: 20px;
  max-width: 620px;
}

/* ====== Botón toggle ====== */
.ceo-toggle-btn {
  background: linear-gradient(90deg, #e24c1c 0%, #d1701f 100%);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 20px;
  font-size: 15px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  line-height: 1.2;
  box-shadow: 0 4px 10px rgba(225, 110, 30, 0.25);
  transition: all 0.25s ease;
}

.ceo-toggle-btn i {
  font-size: 18px;
  line-height: 1;
}

.ceo-toggle-btn:hover {
  background: linear-gradient(90deg, #f66a2e 0%, #e57a28 100%);
  transform: translateY(-1px);
  box-shadow: 0 6px 12px rgba(225, 110, 30, 0.35);
}

/* ====== Contenedor del desplegable ====== */
.ceo-details {
  background: #f8f8f8;
  border: 1px solid #dedede;
  border-radius: 10px;
  padding: 20px;
  margin-top: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
  max-width: 700px;
}

/* ====== Tarjeta individual de experiencia ====== */
.ceo-exp-card {
  background: #fff;
  border: 1px solid #e4e4e4;
  border-radius: 8px;
  padding: 16px 18px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  margin-bottom: 12px;
}

.ceo-exp-card:last-child {
  margin-bottom: 0;
}

/* header: puesto / empresa */
.ceo-exp-header {
  display: flex;
  flex-direction: column;
  margin-bottom: 6px;
}

.ceo-exp-role {
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1d;
  line-height: 1.4;
}

.ceo-exp-company {
  font-size: 14px;
  font-weight: 500;
  color: #d1701f;
  /* toque corporativo cálido */
  line-height: 1.4;
}

/* meta: fechas y ubicación */
.ceo-exp-meta {
  font-size: 13px;
  color: #666;
  line-height: 1.4;
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.ceo-exp-sep {
  color: #999;
}

/* descripción */
.ceo-exp-desc p {
  font-size: 13px;
  color: #333;
  line-height: 1.5;
  margin-bottom: 6px;
}

.ceo-exp-desc p:last-child {
  margin-bottom: 0;
}

/* ====== Animación del desplegable ====== */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.2s ease;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

/* ====== Responsive tweaks ====== */
@media (max-width: 991px) {
  .ceo-section {
    text-align: center;
  }

  .ceo-content {
    margin-top: 30px;
  }

  .ceo-summary,
  .ceo-details {
    margin-left: auto;
    margin-right: auto;
  }

  .ceo-toggle-btn {
    margin-left: auto;
    margin-right: auto;
  }

  .ceo-exp-card {
    text-align: left;
  }
}
</style>
